import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './AboutUs.css'
import { Link } from 'react-router-dom';
const AboutUs = () => {
      const fullText = `Surgery Saathi is your trusted partner in surgical care. We specialize in a variety of procedures, offering personalized support tailored to your unique needs. Our clinic combines the latest medical advancements with a compassionate approach, ensuring exceptional outcomes and prioritizing your safety. From your initial consultation to post-operative care, we are dedicated to making your experience seamless and reassuring. Our skilled team is here to answer your questions and provide the support you need at every step. At Surgery Saathi, your well-being is our top priority, and we are committed to delivering the highest standards of care to enhance your health and confidence.`;

      const [isExpanded, setIsExpanded] = useState(false);

      const toggleText = () => {
        setIsExpanded(!isExpanded);
      };
  return (
    <div>
      <Container>
        <Row>
          <Col className="about_us_home">
            <div className="">
              <div className="tm-spacer" id="tm-spacer-678bfaf9dfb78" />
              <div className="inner_div">
                <div className="image">
                  <img
                    src="/Images/surgery-about.png"
                    alt="h2-img-1"
                  />
                </div>{" "}
              </div>
              <div className="tm-spacer" id="tm-spacer-678bfaf9e028a" />
            </div>
          </Col>
          <Col className="about_us_home_inner">
            <div className="wpb_wrapper">
              <div className="tm-spacer" id="tm-spacer-678bfaf9e1bcd" />
              <div
                className="about_us_second_home_wrapper"
                id="tm-heading-678bfaf9e1d55"
              >
                <h3 className="headingss">About us</h3>
              </div>
              <div className="tm-spacer" id="tm-spacer-678bfaf9e21d0" />
              <div
                className="about_us_second_home_wrapper"
                id="tm-heading-678bfaf9e22d6"
              >
                <h3 className="heading">Best Surgery Center in India</h3>
              </div>
              <div className="tm-spacer" id="tm-spacer-678bfaf9e2717" />
              <div
                className="about_us_second_home_wrapper"
                id="tm-heading-678bfaf9e2826"
              >
                <div className="heading_sub">
                  {isExpanded ? fullText : `${fullText.substring(0, 350)}...`}
                  <span
                    onClick={toggleText}
                    style={{ cursor: "pointer", color: "#0f80a5" }}
                  >
                    {isExpanded ? " Read Less" : " Read More"}
                  </span>
                </div>
              </div>
              <div className="tm-spacer" id="tm-spacer-678bfaf9e2c5c" />
              <div
                className="about_us_second_home_wrapper"
                id="tm-button-678bfaf9e2d98"
              >
                <Link to='/about-us' className="tm-button">
                  <span className="button-text" data-text="More About Us">
                    More About Us{" "}
                  </span>
                </Link>
              </div>
              <div className="tm-spacer" id="tm-spacer-678bfaf9e2e40" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AboutUs
